import React, {Component} from 'react';
import {connect} from 'react-redux';

import {LinkInfo} from 'components/buttons';
import Spinner from 'spinner';
import {DocumentList} from 'components/documents';
import Box from 'components/box';
import {Link} from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumbs';
import {loadDoctorDetail} from 'redux/actions/admin/doctors';
import doctor from 'images/general/doctor.svg';

const mapStateToProps = (state) => ({
  detail: state.doctors.get('doctorDetail'),
  isLoading: state.doctors.get('doctorDetailIsLoading'),
  user: state.auth.get('user')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (id) =>dispatch(loadDoctorDetail(id))
});

class DoctorDetail extends Component {

  renderBreadcrumbs = item => {
    const isAdminInstitution = this.props.user && this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser')
    if(isAdminInstitution) {
      return <Breadcrumbs>
        <li><Link to="/admin/doctors">Облікові записи</Link></li>
        {item.get('user_data') ? (
            <li><Link to={`/admin/doctors/detail/${item.get('id')}`}>{item.get('user_data').get('last_name')} {item.get('user_data').get('first_name')}</Link></li>
          ):(
            null
          )
        }
      </Breadcrumbs>
    }

    return (
      <Breadcrumbs>
        <li><Link to="/admin/">Головна</Link></li>
        <li><Link to="/admin/doctors">Облікові записи</Link></li>
        {item.get('user_data') ? (
            <li><Link to={`/admin/doctors/detail/${item.get('id')}`}>{item.get('user_data').get('last_name')} {item.get('user_data').get('first_name')}</Link></li>
          ):(
            null
          )
        }
      </Breadcrumbs>
    )
  }

  renderEditButton = () => {
    const isAdminInstitution = this.props.user && this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser')
    if(!isAdminInstitution) {
      return <LinkInfo to={`/admin/doctors/detail/${this.props.match.params.id}/edit`}>Редагувати</LinkInfo>
    }
  }

  componentDidMount() {
    this.props.onLoad(this.props.match.params.id);
  }

  render() {
    const item = this.props.detail;

    if (this.props.isLoading) return <Spinner/>;

    return (
      <div>
        {this.renderBreadcrumbs(item)}
           <div>
             <Box>
               {item.getIn(['user_data', 'photo']) ? (
                <img src={item.getIn(['user_data', 'photo'])} alt="doctor" style={{maxWidth: "100px"}}/>
                ) : (
                <img src={doctor} alt="doctor" style={{maxWidth: "100px"}}/>
                )
                }
                 {item.get('user_data') ? (
                    <h2>{item.get('user_data').get('last_name')} {item.get('user_data').get('first_name')} {item.get('user_data').get('middle_name')}</h2>
                 ):(
                   <div>
                </div>
                 )
                }
                <DocumentList>
                  <li><span>Пошта: </span><strong>{item.getIn(['user_data', 'email']) || "Не вказано"}</strong></li>
                  <li><span>Спеціальність: </span><strong>{item.getIn(['profession_classification_data', 'profession_title']) || "Не вказано"}</strong></li>
                  {/*<li><span>Додаткова інформація: </span><strong>{item.get('comment') || "Додаткова інформація відсутня"}</strong></li>*/}
                </DocumentList>
               {this.renderEditButton()}
               </Box>
             </div>
    </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DoctorDetail);


// WEBPACK FOOTER //
// ./src/admin/doctors/detail.js